import { useFeatureFlag } from '@client/hooks/useFeatureFlag';
import { useDebugStore } from '@client/stores/DebugStore';

/**
 * Returns whether debug info panels should be displayed in components.
 * @returns Whether debug info is enabled.
 */
export const useIsDebugInfoEnabled = (): boolean => {
    const isDebugInfoEnabled = useFeatureFlag('enable-debug-info', false);
    const { isForceDebugEnabledFlag } = useDebugStore();

    return isDebugInfoEnabled || isForceDebugEnabledFlag === true;
};
